import React from 'react'
import actionWays from "../redux/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { message, Modal, Form, Input, Button, Checkbox, Row, Col, Select, Card, Cascader, Spin } from "antd";
import { HomeOutlined } from '@ant-design/icons';
import { city } from '../config/city'
import { cityShangHai } from '../config/cityShangHai'
import { getTransactionTodoList, getTransactionDetailById, perfectTransaction, myQueueList, signingConfirmation, reletApply, getSigningConfirmationDetail } from '../utils/api'
import Uploads from '../components/common/Uploads'
import FlowImg from '../components/model/flowImg'
import {
    MARRY_STATUS_OPTIONS,
    isMarryOptionDisabledForApplyType,
    isApplyTypeOptionDisabledForMarry,
    getApplyTypeMarryConflictMessage,
} from '../utils/applyTypeMarryRule'

const { Option } = Select

const HOUSING_QUERY_TUTORIAL_IMAGE = require('../assets/images/prove.png').default

/** 统计逗号分隔的上传图片数量 */
const countUploadImages = (value) => {
    if (value == null || String(value).trim() === '') return 0
    return String(value).split(',').map((s) => s.trim()).filter(Boolean).length
}

/** 证件上传校验：身份证需至少两张，其他证件需至少一张 */
const idCardUploadValidator = (getIdType) => ({ getFieldValue }) => ({
    validator(_, value) {
        const idType = getIdType(getFieldValue)
        const isIdCard = idType === '身份证'
        const count = countUploadImages(value)
        if (count === 0) {
            return Promise.reject(new Error(isIdCard ? '请上传身份证' : '请上传证件'))
        }
        if (isIdCard && count < 2) {
            return Promise.reject(new Error('身份证需上传至少两张图片（正反面）'))
        }
        return Promise.resolve()
    },
})

/** 续租合同 contractAttribute：01/05 为一组，02/03 为另一组 */
const renewalContractAttrIs01Group = (attr) => {
    const a = normalizeContractAttributeCode(attr)
    return a === '01' || a === '05'
}
const normalizeContractAttributeCode = (v) => {
    if (v == null || String(v).trim() === '') return ''
    const s = String(v).trim()
    if (s.length === 1 && /^[0-9]$/.test(s)) return `0${s}`
    return s
}
/** 推断续租合同类型下拉分组（依据原合同 contractAttribute） */
const resolveRenewalContractGroupAttr = (item, data) => {
    const candidates = [
        item?.contractAttribute,
        item?.contract?.contractAttribute,
        data?.contract?.contractAttribute,
        data?.contractAttribute,
        data?.applyAttruble,
    ]
    for (const raw of candidates) {
        const a = normalizeContractAttributeCode(raw)
        if (['01', '02', '03', '05'].includes(a)) return a
    }
    return ''
}
/** 将详情接口数据解析为续租合同类型表单值 applyAttruble（01/05/03/02） */
const parseRenewalFormApplyAttruble = (data, groupAttr) => {
    if (!data) return undefined
    const fromApply = normalizeContractAttributeCode(data.applyAttruble)
    if (['01', '02', '03', '05'].includes(fromApply)) return fromApply
    const fromCode = normalizeContractAttributeCode(data.contractAttribute)
    if (['01', '02', '03', '05'].includes(fromCode)) return fromCode
    const label = data.applyAttruble != null ? String(data.applyAttruble).trim() : ''
    if (!label) return undefined
    if (renewalContractAttrIs01Group(groupAttr)) {
        return label === '单位' ? '05' : '01'
    }
    return label === '单位' ? '02' : '03'
}

const shanghaiMunicipalChildren = (cityShangHai[0]?.children || []).find((c) => c.value === '市辖区' || c.label === '市辖区')
/** 市辖区下的区列表，供工作单位地址「区」下拉使用 */
const SHANGHAI_DISTRICT_OPTIONS = (shanghaiMunicipalChildren?.children || []).map((d) => ({
    value: d.value,
    label: d.label,
}))

const JOINT_ID_CARD_ADDITION_ITEM = { transactionAdditionType: '共同申请人附件', kind: '身份证', content: '', thumbnail: '' }
const JOINT_HOUSING_ADDITION_ITEM = { transactionAdditionType: '共同申请人附件', kind: '住房情况', content: '', thumbnail: '' }

/** 共同申请人 signingConfirmationAdditionList：身份证（可多条）+ 住房情况（一条），与接口对齐 */
const buildJointAdditionListForPerson = (p) => {
    const apiList = (p && p.signingConfirmationAdditionList) || []
    const idRows = apiList.filter((x) => x && x.kind === '身份证')
    const idPart = idRows.length ? JSON.parse(JSON.stringify(idRows)) : [JSON.parse(JSON.stringify(JOINT_ID_CARD_ADDITION_ITEM))]
    const housingFound = apiList.find((x) => x && x.kind === '住房情况')
    const housingPart = housingFound
        ? {
            ...housingFound,
            transactionAdditionType: housingFound.transactionAdditionType || '共同申请人附件',
            kind: '住房情况',
        }
        : JSON.parse(JSON.stringify(JOINT_HOUSING_ADDITION_ITEM))
    return [...idPart, housingPart]
}

const defaultJointAdditionListRef = () => [
    JSON.parse(JSON.stringify(JOINT_ID_CARD_ADDITION_ITEM)),
    JSON.parse(JSON.stringify(JOINT_HOUSING_ADDITION_ITEM)),
]

const APPLY_TYPE_OPTIONS = ['单身人士', '三人及以下家庭', '两孩家庭', '三孩家庭']

/** 展示结婚证上传的婚姻现状；已婚必填，丧偶/离异选填 */
const MARRY_CERT_SHOW_STATUSES = ['已婚', '丧偶', '离异']

/** 签约确认主申请人附件顺序与 kind，与接口 signingConfirmationAdditionList 对齐 */
const MAIN_SIGNING_ATTACHMENT_KINDS = ['身份证', '结婚证', '就业证明', '住房情况']

const mainSigningRow = (kind) => ({
    transactionAdditionType: '主申请人附件',
    kind,
    content: '',
    thumbnail: '',
})

const buildMainSigningAdditionListFromApi = (apiList) => {
    const api = apiList || []
    return MAIN_SIGNING_ATTACHMENT_KINDS.map((kind) => {
        const found = api.find((x) => x && x.kind === kind)
            || (kind === '就业证明' ? api.find((x) => x && x.kind === '劳动合同') : null)
        return found
            ? {
                ...found,
                transactionAdditionType: found.transactionAdditionType || '主申请人附件',
                kind,
            }
            : mainSigningRow(kind)
    })
}

/** 18 位身份证第 17 位、15 位身份证末位：奇数为男，偶数为女 */
const sexFromIdno = (idno) => {
    if (idno == null || idno === '') return undefined
    const s = String(idno).trim()
    if (s.length === 18) {
        const n = parseInt(s.charAt(16), 10)
        if (Number.isNaN(n)) return undefined
        return n % 2 === 1 ? '男' : '女'
    }
    if (s.length === 15) {
        const n = parseInt(s.charAt(14), 10)
        if (Number.isNaN(n)) return undefined
        return n % 2 === 1 ? '男' : '女'
    }
    return undefined
}

/** 提交时单位地址各段用 / 拼接 */
const buildCompanyAddressForSubmit = (o) => {
    if (!o || typeof o !== 'object') return ''
    const parts = []
    const base = o.companyAddress
    if (base != null && String(base).trim() !== '') parts.push(String(base).trim())
    const d = o.companyDistrict
    if (d != null && String(d).trim() !== '') parts.push(String(d).trim())
    if (d === '浦东新区' && o.companyPudongRing != null && String(o.companyPudongRing).trim() !== '') {
        parts.push(String(o.companyPudongRing).trim())
    }
    if (o.workRoad != null && String(o.workRoad).trim() !== '') parts.push(`${String(o.workRoad).trim()}路`)
    if (o.workLane != null && String(o.workLane).trim() !== '') parts.push(`${String(o.workLane).trim()}弄`)
    if (o.workBranch != null && String(o.workBranch).trim() !== '') parts.push(`${String(o.workBranch).trim()}支弄`)
    if (o.workNo != null && String(o.workNo).trim() !== '') parts.push(`${String(o.workNo).trim()}号`)
    if (o.workRoom != null && String(o.workRoom).trim() !== '') parts.push(`${String(o.workRoom).trim()}室`)
    return parts.join('/')
}

/** 将接口返回的 companyAddress 按 / 拆分为各单位地址字段 */
const parseCompanyAddressFromApi = (address) => {
    const out = {}
    if (address == null || String(address).trim() === '') return out
    const raw = String(address).trim()

    // 无 / 且以「区」结尾：整段回显到区下拉
    if (!raw.includes('/') && raw.endsWith('区')) {
        out.companyDistrict = raw
        return out
    }

    const parts = raw.split('/').map((p) => p.trim()).filter(Boolean)
    if (!parts.length) return out

    const districtValues = SHANGHAI_DISTRICT_OPTIONS.map((d) => d.value)
    const pudongRings = ['外环外', '外环内']
    let idx = 0

    const isStructuredPart = (p) => (
        districtValues.includes(p)
        || pudongRings.includes(p)
        || /路$/.test(p)
        || /支弄$/.test(p)
        || /弄$/.test(p)
        || /号$/.test(p)
        || /室$/.test(p)
    )

    if (parts[idx] && !isStructuredPart(parts[idx])) {
        out.companyAddress = parts[idx]
        idx += 1
    }

    if (parts[idx] && districtValues.includes(parts[idx])) {
        out.companyDistrict = parts[idx]
        idx += 1
        if (out.companyDistrict === '浦东新区' && parts[idx] && pudongRings.includes(parts[idx])) {
            out.companyPudongRing = parts[idx]
            idx += 1
        }
    }

    const assignBySuffix = (p) => {
        if (p.endsWith('支弄')) {
            out.workBranch = p.slice(0, -2)
            return true
        }
        if (p.endsWith('路')) {
            out.workRoad = p.slice(0, -1)
            return true
        }
        if (p.endsWith('弄')) {
            out.workLane = p.slice(0, -1)
            return true
        }
        if (p.endsWith('号')) {
            out.workNo = p.slice(0, -1)
            return true
        }
        if (p.endsWith('室')) {
            out.workRoom = p.slice(0, -1)
            return true
        }
        return false
    }

    while (idx < parts.length) {
        if (!assignBySuffix(parts[idx])) {
            out.companyAddress = out.companyAddress
                ? `${out.companyAddress}/${parts[idx]}`
                : parts[idx]
        }
        idx += 1
    }

    return out
}

class modalBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFlag: false,
            expireTime: '',
            showPudongWorkRingSection: false,
            signingMarry: '',
            signingApplyType: '',
            applyTypeLocked: false,
            marryLocked: false,
            dataList: null,
            newProjectName: '',
            newHouseType: '',
            renewalContractNo: '',
            renewalContractId: '',
            renewalProjectName: '',
            renewalHouseNo: '',
            renewalContractAttribute: '',
            renewalLoading: false,
        }
    }
    isRenewalModal = () => !!(this.props.renewalApply || this.props.renewalApplyEdit)
    getRenewalContractInfo = (contract) => {
        const c = contract || this.props.renewalContract || {}
        const house = c.house || {}
        const contractAttribute = c.contractAttribute != null ? String(c.contractAttribute).trim() : ''
        return {
            id: c.id != null ? c.id : '',
            contractNo: c.contractNo != null ? String(c.contractNo).trim() : '',
            projectName: house.projectName != null ? String(house.projectName).trim() : '',
            houseNo: house.houseNo != null ? String(house.houseNo).trim() : '',
            contractAttribute,
        }
    }
    componentDidMount() {
        if (this.props.renewalApplyEdit) {
            this.openReletApplyEditForm()
        } else if (this.props.renewalApply) {
            this.openRenewalApplyFormOnly()
        } else if (this.props.showModalBox) {
            this.sureAsurname('showModalBox')
        } else if (this.props.enableAutoTodoCheck !== false && this.props.userLoginInfo?.idno) {
            this.sureAsurname('idno')
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.renewalApplyEdit && this.props.reletApplyId !== prevProps.reletApplyId) {
            this.openReletApplyEditForm()
            return
        }
        if (this.props.renewalApply && this.props.renewalContract !== prevProps.renewalContract) {
            const info = this.getRenewalContractInfo(this.props.renewalContract)
            this.setState({
                renewalContractNo: info.contractNo,
                renewalContractId: info.id,
                renewalProjectName: info.projectName,
                renewalHouseNo: info.houseNo,
                renewalContractAttribute: info.contractAttribute,
            })
        }
    }
    closeManualModal = () => {
        this.setState({ showFlag: false, renewalLoading: false })
        if (this.props.renewalApplyEdit && this.props.changeRenewalEditModalBox) {
            this.props.changeRenewalEditModalBox()
        } else if (this.props.renewalApply && this.props.changeRenewalModalBox) {
            this.props.changeRenewalModalBox()
        } else if (this.props.changeShowModalBox) {
            this.props.changeShowModalBox()
        }
    }
    /** 续租申请：不调接口，仅回填登录信息，其余留空 */
    openRenewalApplyFormOnly = () => {
        const login = this.props.userLoginInfo || {}
        const { id, contractNo, projectName, houseNo, contractAttribute } = this.getRenewalContractInfo()
        const dataList = {
            username: login.username || '',
            mobile: login.mobile || login.telephone || '',
            idno: login.idno || '',
            signingConfirmationApplicantBeanList: [],
            applyType: undefined,
            applyAttruble: contractAttribute || undefined,
        }
        const sexByIdno = sexFromIdno(dataList.idno)
        if (sexByIdno) {
            dataList.sex = sexByIdno
        }
        this.jointAdditionListRefs = []
        this.mainAdditionListRef = buildMainSigningAdditionListFromApi(null)
        this.setState({
            showFlag: true,
            expireTime: '',
            dataList,
            signingMarry: '',
            signingApplyType: '',
            applyTypeLocked: false,
            marryLocked: false,
            showPudongWorkRingSection: false,
            renewalContractNo: contractNo,
            renewalContractId: id,
            renewalProjectName: projectName,
            renewalHouseNo: houseNo,
            renewalContractAttribute: contractAttribute,
        }, () => {
            this.refs.showFlagRef?.setFieldsValue(dataList)
        })
    }
    /** 续租修改：拉取签约确认详情并回填表单 */
    openReletApplyEditForm = async () => {
        const reletApplyId = this.props.reletApplyId
        if (!reletApplyId) return
        this.setState({ showFlag: true, renewalLoading: true })
        const list = await getSigningConfirmationDetail({ id: reletApplyId })
        if (list.code != 0) {
            message.error(list.message)
            this.setState({ showFlag: false, renewalLoading: false })
            this.props.changeRenewalEditModalBox?.()
            return
        }
        const dataList = list.data || {}
        const item = this.props.reletApplyItem || {}
        const house = dataList.house || item.house || {}
        const groupAttr = resolveRenewalContractGroupAttr(item, dataList)
        const formApplyAttruble = parseRenewalFormApplyAttruble(dataList, groupAttr)
        dataList.applyAttruble = formApplyAttruble
        delete dataList.contractAttribute
        if (dataList.companyAddress && String(dataList.companyAddress).trim() !== '') {
            const parsed = parseCompanyAddressFromApi(dataList.companyAddress)
            Object.assign(dataList, parsed)
            if (!parsed.companyAddress) {
                delete dataList.companyAddress
            }
        }
        this.populateFormFromSigningDetail(dataList, {
            renewalLoading: false,
            expireTime: '',
            renewalContractNo: dataList.contractNo != null ? String(dataList.contractNo).trim() : (item.contractNo != null ? String(item.contractNo).trim() : ''),
            renewalContractId: dataList.contractId != null ? dataList.contractId : (item.contractId != null ? item.contractId : ''),
            renewalProjectName: house.projectName != null ? String(house.projectName).trim() : (dataList.projectName != null ? String(dataList.projectName).trim() : ''),
            renewalHouseNo: house.houseNo != null ? String(house.houseNo).trim() : (dataList.houseNo != null ? String(dataList.houseNo).trim() : ''),
            renewalContractAttribute: groupAttr,
        })
    }
    populateFormFromSigningDetail = (dataList, extraState = {}) => {
        const sexByIdno = sexFromIdno(dataList.idno)
        if (sexByIdno) {
            dataList.sex = sexByIdno
        }
        if (dataList.applyType && dataList.applyType !== '单身人士') {
            if (!Array.isArray(dataList.signingConfirmationApplicantBeanList) || dataList.signingConfirmationApplicantBeanList.length === 0) {
                dataList.signingConfirmationApplicantBeanList = [{}]
            }
        } else if (!Array.isArray(dataList.signingConfirmationApplicantBeanList)) {
            dataList.signingConfirmationApplicantBeanList = []
        }
        for (let i in dataList.signingConfirmationApplicantBeanList) {
            if (!dataList.signingConfirmationApplicantBeanList[i]) {
                dataList.signingConfirmationApplicantBeanList = []
                break
            }
            dataList.signingConfirmationApplicantBeanList[i].id = i
        }
        const jointRefs = []
        for (let i = 0; i < (dataList.signingConfirmationApplicantBeanList || []).length; i++) {
            const p = dataList.signingConfirmationApplicantBeanList[i]
            jointRefs[i] = buildJointAdditionListForPerson(p)
            for (let j in jointRefs[i]) {
                const row = jointRefs[i][j]
                if (row.kind && row.content) {
                    p[row.kind] = row.content
                    p[row.kind + '缩略'] = row.thumbnail || row.content
                }
            }
        }
        this.jointAdditionListRefs = jointRefs
        this.mainAdditionListRef = buildMainSigningAdditionListFromApi(dataList.signingConfirmationAdditionList)
        for (let i in this.mainAdditionListRef) {
            const row = this.mainAdditionListRef[i]
            if (row.kind && row.content) {
                dataList[row.kind] = row.content
                dataList[row.kind + '缩略'] = row.thumbnail || row.content
            }
        }
        const applyTypeFromApi = dataList.applyType != null && String(dataList.applyType).trim() !== ''
        const marryFromApi = dataList.marry != null && String(dataList.marry).trim() !== ''
        if (!applyTypeFromApi) {
            dataList.applyType = undefined
        }
        this.setState({
            dataList,
            signingMarry: dataList.marry || '',
            signingApplyType: applyTypeFromApi ? dataList.applyType : '',
            applyTypeLocked: this.isRenewalModal() ? false : applyTypeFromApi,
            marryLocked: this.isRenewalModal() ? false : marryFromApi,
            showPudongWorkRingSection: dataList.companyDistrict === '浦东新区',
            ...extraState,
        }, () => {
            this.refs.showFlagRef?.setFieldsValue({
                ...dataList,
                applyAttruble: dataList.applyAttruble,
            })
        })
    }
    sureAsurname = async (type) => {
        if (type == 'idno') {
            let list = await getTransactionTodoList({ idno: this.props.userLoginInfo.idno })
            if (list.code == 0) {
                if (list.data?.todoList?.expireTime) {
                    this.setState({
                        showFlag: true,
                        expireTime: list.data?.todoList?.expireTime,
                        newProjectName: list.data.projectName,
                        newHouseType: list.data.houseType,
                    }, () => {
                        this.getTransactionTodoList(list)
                    })
                }
                this.props.showMoveBox(list.data?.perfectStatus)
            } else {
                message.error(list.message)
            }
        } else if (type == 'showModalBox') {
            this.setState({
                showFlag: true,
            }, () => {
                this.getTransactionTodoList()
            })
        }
    }
    getTransactionTodoList = async (lists) => {
        let list = null
        if (lists) {
            list = lists
        } else {
            list = await getTransactionDetailById({ id: this.props.ModalBoxId })
        }
        if (list.code == 0) {
            this.populateFormFromSigningDetail(list.data)
        } else {
            message.error(list.message)
        }
    }
    // Cascader = (v) => {
    //     // const dataList = this.state.dataList
    //     const dataList = {}
    //     if (v[0] == '上海市') {
    //         dataList.registeredType = '本市'
    //     } else {
    //         dataList.registeredType = '外省市'
    //     }
    //     dataList.province = v
    //     this.refs.showFlagRef.setFieldsValue(dataList)
    // }
    changeApplyAttruble = (v) => {
        this.setState({
            sqTypes: v,
        })
    }
    clearMainMarriageCert = () => {
        const form = this.refs.showFlagRef
        if (!form) return
        form.setFieldsValue({
            结婚证: undefined,
            结婚证缩略: undefined,
        })
        if (this.mainAdditionListRef) {
            for (let i in this.mainAdditionListRef) {
                if (this.mainAdditionListRef[i].kind === '结婚证') {
                    this.mainAdditionListRef[i].content = ''
                    this.mainAdditionListRef[i].thumbnail = ''
                }
            }
        }
    }
    onApplyTypeChange = (v) => {
        this.setState({ signingApplyType: v || '' })
        const form = this.refs.showFlagRef
        if (!form) return
        const marry = form.getFieldValue('marry')
        if (v === '单身人士' && marry === '已婚') {
            form.setFieldsValue({ marry: undefined })
            this.setState({ signingMarry: '' })
            this.clearMainMarriageCert()
        }
        if (!v || v === '单身人士') return
        const cur = form.getFieldsValue().signingConfirmationApplicantBeanList || []
        if (cur.length === 0) {
            form.setFieldsValue({ signingConfirmationApplicantBeanList: [{}] })
            this.jointAdditionListRefs = [defaultJointAdditionListRef()]
        }
    }
    onMainApplicantMarryChange = (v) => {
        this.setState({ signingMarry: v })
        const form = this.refs.showFlagRef
        if (!form) return
        const applyType = form.getFieldValue('applyType')
        if (v === '已婚' && applyType === '单身人士') {
            form.setFieldsValue({ applyType: undefined })
            this.setState({ signingApplyType: '' })
        }
        if (v === '单身') {
            this.clearMainMarriageCert()
        }
    }
    onWorkCompanyDistrictChange = (value) => {
        this.setState({ showPudongWorkRingSection: value === '浦东新区' })
        if (value !== '浦东新区' && this.refs.showFlagRef) {
            this.refs.showFlagRef.setFieldsValue({ companyPudongRing: undefined })
        }
    }
    /** 主申请人签约附件：表单字段「kind」「kind缩略」与 signingConfirmationAdditionList 同步 */
    setMainSigningUploadImages = (img, index, indexUp, data, indexFu, imgTmp, indexTmp) => {
        const form = this.refs.showFlagRef
        if (!form) return
        form.setFieldsValue({ [index]: img.toString(), [indexTmp]: imgTmp.toString() })
        const values = form.getFieldsValue()
        if (!this.mainAdditionListRef) return
        for (let i in this.mainAdditionListRef) {
            if (this.mainAdditionListRef[i].kind === index) {
                this.mainAdditionListRef[i].content = values[index] || ''
                this.mainAdditionListRef[i].thumbnail = values[indexTmp] || values[index] || ''
            }
        }
    }
    /** 共同申请人签约附件：表单字段与 signingConfirmationAdditionList 各 kind 行同步 */
    setJointIdCardImages = (img, index, indexUp, data, indexFu, imgTmp, indexTmp) => {
        const form = this.refs.showFlagRef
        if (!form || data?.name !== 'signingConfirmationApplicantBeanList' || indexUp == null) return
        const cur = form.getFieldsValue()
        const tpl = [...(cur.signingConfirmationApplicantBeanList || [])]
        if (!tpl[indexUp]) return
        tpl[indexUp] = { ...tpl[indexUp], [index]: img.toString(), [indexTmp]: imgTmp.toString() }
        form.setFieldsValue({ signingConfirmationApplicantBeanList: tpl })
        const person = form.getFieldsValue().signingConfirmationApplicantBeanList[indexUp]
        const refs = this.jointAdditionListRefs
        if (!refs || !refs[indexUp]) return
        for (let j in refs[indexUp]) {
            if (refs[indexUp][j].kind === index) {
                refs[indexUp][j].content = person[index] || ''
                refs[indexUp][j].thumbnail = person[indexTmp] || person[index] || ''
            }
        }
    }
    onFinishFailed = ({ values, errorFields, outOfDate }) => {
        message.error('提交失败，您有信息未填写')
    }
    onFinish = async (values) => {
        let opts = {}
        opts = values
        if (!this.isRenewalModal()) {
            opts.id = (this.state.dataList && this.state.dataList.id) || opts.id
        }
        if (this.state.dataList && this.state.dataList.todoList) {
            opts.todoList = {}
            opts.todoList.id = this.state.dataList.todoList.id
        }
        const additionList = JSON.parse(JSON.stringify(this.mainAdditionListRef || buildMainSigningAdditionListFromApi(null)))
        const fv = this.refs.showFlagRef ? this.refs.showFlagRef.getFieldsValue() : {}
        MAIN_SIGNING_ATTACHMENT_KINDS.forEach((kind) => {
            const row = additionList.find((r) => r.kind === kind)
            if (!row) return
            row.content = (fv[kind] != null ? fv[kind] : opts[kind] || '').toString()
            row.thumbnail = (fv[kind + '缩略'] != null ? fv[kind + '缩略'] : opts[kind + '缩略'] || row.content || '').toString()
        })
        if (opts.marry === '已婚') {
            const marryContent = (fv['结婚证'] != null ? fv['结婚证'] : opts['结婚证'] || '').toString().trim()
            if (!marryContent) {
                message.error('请上传结婚证')
                return
            }
            opts.signingConfirmationAdditionList = additionList
        } else if (opts.marry === '丧偶' || opts.marry === '离异') {
            const marryContent = (fv['结婚证'] != null ? fv['结婚证'] : opts['结婚证'] || '').toString().trim()
            opts.signingConfirmationAdditionList = marryContent
                ? additionList
                : additionList.filter((r) => r && r.kind !== '结婚证')
        } else {
            opts.signingConfirmationAdditionList = additionList.filter((r) => r && r.kind !== '结婚证')
        }
        MAIN_SIGNING_ATTACHMENT_KINDS.forEach((kind) => {
            delete opts[kind]
            delete opts[kind + '缩略']
        })
        const personFv = fv.signingConfirmationApplicantBeanList || []
        const rawPersons = opts.signingConfirmationApplicantBeanList || []
        opts.signingConfirmationApplicantBeanList = rawPersons.map((p, i) => {
            const ref = (this.jointAdditionListRefs && this.jointAdditionListRefs[i])
                ? JSON.parse(JSON.stringify(this.jointAdditionListRefs[i]))
                : defaultJointAdditionListRef()
            const rowForm = personFv[i] || {}
            for (let j in ref) {
                if (ref[j].kind === '身份证') {
                    ref[j].content = (rowForm['身份证'] != null ? rowForm['身份证'] : p['身份证'] || '').toString()
                    ref[j].thumbnail = (rowForm['身份证缩略'] != null ? rowForm['身份证缩略'] : p['身份证缩略'] || ref[j].content || '').toString()
                }
                if (ref[j].kind === '住房情况') {
                    ref[j].content = (rowForm['住房情况'] != null ? rowForm['住房情况'] : p['住房情况'] || '').toString()
                    ref[j].thumbnail = (rowForm['住房情况缩略'] != null ? rowForm['住房情况缩略'] : p['住房情况缩略'] || ref[j].content || '').toString()
                }
            }
            const nextP = { ...p }
            delete nextP['身份证']
            delete nextP['身份证缩略']
            delete nextP['住房情况']
            delete nextP['住房情况缩略']
            nextP.signingConfirmationAdditionList = ref
            return nextP
        })
        const applyType = opts.applyType || fv.applyType
        const applyMarryConflict = getApplyTypeMarryConflictMessage(applyType, opts.marry)
        if (applyMarryConflict) {
            message.error(applyMarryConflict)
            return
        }
        if (applyType && applyType !== '单身人士') {
            const pl = opts.signingConfirmationApplicantBeanList || []
            if (pl.length < 1 || pl.length > 4) {
                message.error('需至少1名、最多4名共同申请人')
                return
            }
        } else if (applyType === '单身人士') {
            const pl = opts.signingConfirmationApplicantBeanList || []
            if (pl.length > 4) {
                message.error('最多4名共同申请人')
                return
            }
        }
        const mergeAddr = { ...opts, ...fv }
        const workUnitKeys = ['companyDistrict', 'companyPudongRing', 'workRoad', 'workLane', 'workBranch', 'workNo', 'workRoom']
        const hasWorkUnitFields = workUnitKeys.some((k) => mergeAddr[k] != null && String(mergeAddr[k]).trim() !== '')
        if (hasWorkUnitFields) {
            opts.companyAddress = buildCompanyAddressForSubmit(mergeAddr)
        } else {
            const baseCompany = (opts.companyAddress != null && String(opts.companyAddress).trim() !== ''
                ? String(opts.companyAddress).trim()
                : (fv.companyAddress != null ? String(fv.companyAddress).trim() : ''))
            opts.companyAddress = baseCompany
        }
        ; workUnitKeys.forEach((k) => {
            delete opts[k]
        })
        opts.projectName = this.state.newProjectName
        opts.houseType = this.state.newHouseType
        if (this.isRenewalModal()) {
            if (this.props.renewalApplyEdit) {
                opts.id = this.props.reletApplyId
                opts.contractNo = opts.contractNo || this.state.renewalContractNo
                opts.projectName = this.state.renewalProjectName || opts.projectName
            } else if (this.props.renewalApply) {
                delete opts.id
                opts.contractNo = this.state.renewalContractNo || this.getRenewalContractInfo().contractNo
                opts.projectName = this.state.renewalProjectName || this.getRenewalContractInfo().projectName
            }
        }
        // if (typeof opts.province !== 'string') {
        //     opts.province = JSON.stringify(opts.province)
        // }
        // console.log(values);
        // console.log(opts);
        // console.log(this.state.dataList);
        // return
        const submitApi = this.isRenewalModal() ? reletApply : signingConfirmation
        let list = await submitApi(opts)
        if (list.code === 0) {
            message.success(this.props.renewalApplyEdit ? '操作成功' : (this.isRenewalModal() ? '续租申请成功' : '确认签约成功'))
            this.setState({
                showFlag: false,
                expireTime: '',
                renewalLoading: false,
            })
            if (this.props.renewalApplyEdit && this.props.changeRenewalEditModalBox) {
                this.props.changeRenewalEditModalBox(true)
            } else {
                if (this.props.renewalApply && this.props.changeRenewalModalBox) {
                    this.props.changeRenewalModalBox()
                }
                window.location.reload();
            }
        } else {
            message.error(list.message)
        }
    }
    render() {
        const { checksFunc, drawerVisible, needFixed, isModalVisible, loading, personal, loginLoading, signView, timer, isChangePassword, isApplyFor, applyForShow, showFlag, registeredType, sqTypes, showInFlag, showCheckFlag, expireTime, dataList, showPudongWorkRingSection, signingMarry, signingApplyType, applyTypeLocked, marryLocked, renewalContractNo, renewalProjectName, renewalHouseNo, renewalContractAttribute, renewalLoading } = this.state
        const { showModalBox, renewalApply, renewalApplyEdit, changeShowModalBox } = this.props
        const renewalMode = this.isRenewalModal()
        const manualModal = showModalBox || renewalMode
        return (
            <div>
                <style>{`
                    .modal-box-modal .ant-modal-content,
                    .modal-box-modal .ant-modal-body {
                        overflow: visible;
                    }
                    .modal-box-modal .ant-modal-body {
                        padding-top: 70px;
                    }
                    .modal-renewal-house-info {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        padding: 10px 14px;
                        background: #F3F8FF;
                        border: 1px solid #B8D4FF;
                        border-radius: 6px;
                        line-height: 22px;
                    }
                    .modal-renewal-house-info .modal-renewal-house-icon {
                        color: #1890FF;
                        font-size: 16px;
                        flex-shrink: 0;
                    }
                    .modal-renewal-house-info .modal-renewal-house-label {
                        color: rgba(0, 0, 0, 0.85);
                        flex-shrink: 0;
                    }
                    .modal-renewal-house-info .modal-renewal-house-value {
                        color: #1890FF;
                        word-break: break-all;
                    }
                    .modal-renewal-hint {
                        margin-top: 8px;
                        font-size: 12px;
                        color: #EF0F0F;
                        line-height: 20px;
                    }
                    .modalWorkUnitAddrItem .ant-form-item-explain,
                    .modalWorkUnitAddrItem .ant-form-item-explain-connected {
                        display: none !important;
                        min-height: 0 !important;
                    }
                `}</style>
                <Modal className="modal-box-modal" width={1200} visible={showFlag || renewalLoading} closable={manualModal} maskClosable={manualModal} onCancel={this.closeManualModal} footer={false}>
                    <Spin spinning={renewalLoading}>
                        <div style={{ position: 'relative', margin: '0 -24px', marginTop: '-70px', padding: '0 24px 16px', backgroundColor: '#F0F5FA', zIndex: 1 }}>
                            <div style={{ height: '70px', position: 'relative', display: 'flex', justifyContent: 'center' }}>
                                <img
                                    alt=""
                                    style={{ position: 'absolute', top: '-55px', left: '50%', transform: 'translateX(-50%)', zIndex: 2, pointerEvents: 'none' }}
                                    src={require('../assets/images/topImg.png').default}
                                />
                            </div>
                            {!renewalMode ? (
                                <>
                                    <h4 style={{ fontWeight: 'bold' }}>如您确定要房，请您确认并补全以下信息：</h4>
                                    {expireTime ? <p style={{ color: '#EF0F0F' }}>
                                        此页面于（{expireTime}）自动关闭，请在上述时间内确认签约，逾期未确认视为放弃本次选房，需重新登记。
                                    </p> : null}
                                </>
                            ) : (
                                <>
                                    <div className="modal-renewal-house-info">
                                        <HomeOutlined className="modal-renewal-house-icon" />
                                        <span className="modal-renewal-house-label">已入住房源：</span>
                                        <span className="modal-renewal-house-value">
                                            {(renewalProjectName || '') + (renewalHouseNo || '') || '—'}
                                        </span>
                                    </div>
                                    <div className="modal-renewal-hint">续租合同统一两年一签</div>
                                </>
                            )}
                        </div>
                        <Form
                            name="showFlagBox"
                            layout="horizontal"
                            scrollToFirstError={true}
                            ref={'showFlagRef'}
                            // preserve={true}
                            labelCol={{ span: 9 }}
                            labelWrap={true}
                            colon={false}
                            className="showFlagBox-form"
                            onFinish={(e) => { tapOnce(this.onFinish, e, 500) }}
                            onFinishFailed={(e) => { tapOnce(this.onFinishFailed, e, 500) }}
                            style={{ marginTop: renewalMode ? '8px' : '0' }}
                        >
                            <Card bordered={false}>
                                <Row gutter={[48, 8]} align="middle">
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='applyType' label='申请类型：'
                                            rules={[{ required: true, message: '请选择申请类型' }]}>
                                            <Select placeholder="请选择" disabled={renewalMode ? false : applyTypeLocked} onChange={this.onApplyTypeChange}>
                                                {APPLY_TYPE_OPTIONS.map((v) => (
                                                    <Option
                                                        key={v}
                                                        value={v}
                                                        disabled={isApplyTypeOptionDisabledForMarry(v, signingMarry)}
                                                    >
                                                        {v}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[48, 8]} align="middle">
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        {renewalMode ? (
                                            <Form.Item
                                                key={`renewal-contract-attr-${renewalContractAttrIs01Group(renewalContractAttribute) ? '01group' : '03group'}`}
                                                name='applyAttruble'
                                                label='续租合同类型：'
                                                rules={[{ required: true, message: '请选择续租合同类型' }]}
                                            >
                                                {renewalContractAttrIs01Group(renewalContractAttribute) ? (
                                                    <Select placeholder="请选择" onChange={(value) => this.changeApplyAttruble(value)}>
                                                        <Option value='01'>个人</Option>
                                                        <Option value='05'>单位</Option>
                                                    </Select>
                                                ) : (
                                                    <Select placeholder="请选择" onChange={(value) => this.changeApplyAttruble(value)}>
                                                        <Option value='03'>个人</Option>
                                                        <Option value='02'>单位</Option>
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        ) : (
                                            <Form.Item name='applyAttruble' label='申请属性：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Select placeholder="请选择" onChange={(value) => this.changeApplyAttruble(value)}>
                                                    <Option value='个人'>个人</Option>
                                                    <Option value='单位'>单位</Option>
                                                </Select>
                                            </Form.Item>
                                        )}
                                    </Col>
                                </Row>
                                {!renewalMode ? (
                                    <Row gutter={[48, 8]}>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ color: 'red' }} className='btmRedLeft'>
                                            <p>个人：</p>
                                            <p>1.合同乙方为主申请人，合同签署由本人签字。</p>
                                            <p>2.房屋租金由个人支付，发票抬头为个人抬头。</p>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ color: 'red' }} className='btmRedRight'>
                                            <p>单位：</p>
                                            <p>1.合同乙方为申请人所在工作单位，合同签署由单位加盖合同章、法人章。</p>
                                            <p>2.房屋租金可由单位支付或个人支付，发票抬头均为单位抬头。</p>
                                            {/* <p>3.可在单位及入住人同意后变更本单位其他持有保租房准入资格的员工入住。</p>
                                    <p>4.符合条件的特定情况下可申请安排同单位多名持有保租房准入资格的员工合租。</p> */}
                                        </Col>
                                    </Row>
                                ) : null}
                            </Card>
                            <div style={{ maxHeight: '60vh', overflowY: 'scroll' }}>
                                <Card title={<div id="application" style={{ borderLeft: '3px solid #1890FF', padding: '0 0 0 5px', fontWeight: 'bold' }}>主申请人</div>} bordered={false}>
                                    <Row gutter={[48, 8]}>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='username' label='姓名：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Input disabled={renewalMode} />
                                            </Form.Item>
                                        </Col>
                                        {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='sex' label='性别：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col> */}
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='sex' label='性别：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Select placeholder="请选择" disabled={renewalMode}>
                                                    <Option value='男'>男</Option>
                                                    <Option value='女'>女</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='idType' label='证件类型：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Select
                                                    placeholder="请选择"
                                                    onChange={() => this.refs.showFlagRef?.validateFields(['身份证'])}
                                                >
                                                    <Option value='身份证'>身份证</Option>
                                                    <Option value='其他'>其他</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='idno' label='证件号码：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Input disabled={renewalMode} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='localHousehold' label='是否本市户籍：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Select placeholder="请选择">
                                                    <Option value='是'>是</Option>
                                                    <Option value='否'>否</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='marry' label='婚姻现状：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Select placeholder="请选择" onChange={this.onMainApplicantMarryChange} disabled={renewalMode ? false : marryLocked}>
                                                    {MARRY_STATUS_OPTIONS.map((status) => (
                                                        <Option
                                                            key={status}
                                                            value={status}
                                                            disabled={isMarryOptionDisabledForApplyType(status, signingApplyType)}
                                                        >
                                                            {status}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='education' label='学历：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Select placeholder="请选择">
                                                    <Option value='博士'>博士</Option>
                                                    <Option value='硕士'>硕士</Option>
                                                    <Option value='本科'>本科</Option>
                                                    <Option value='大专、高职'>大专、高职</Option>
                                                    <Option value='高中'>高中</Option>
                                                    <Option value='中专、职校'>中专、职校</Option>
                                                    <Option value='初中及以下'>初中及以下</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='mobile' label='联系电话：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='employmentProofType' label='就业证明类型：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Select placeholder="请选择">
                                                    <Option value='劳动合同'>劳动合同</Option>
                                                    <Option value='劳务合同'>劳务合同</Option>
                                                    <Option value='聘用协议'>聘用协议</Option>
                                                    <Option value='录用通知'>录用通知</Option>
                                                    <Option value='自主创业的工商记录'>自主创业的工商记录</Option>
                                                    <Option value='其他'>其他</Option>
                                                    <Option value='毕业证书'>毕业证书</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='socialSecurityRecord' label='社保记录：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Select placeholder="请选择">
                                                    <Option value='是'>是</Option>
                                                    <Option value='否'>否</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='companyName' label='工作单位名称：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='industryCategory' label='所在行业类别：'
                                                rules={[{ required: true, message: '', }]}>
                                                <Select placeholder="请选择">
                                                    <Option value='中层及以上管理人员'>中层及以上管理人员</Option>
                                                    <Option value='科学研究人员'>科学研究人员</Option>
                                                    <Option value='航空航天工程技术人员'>航空航天工程技术人员</Option>
                                                    <Option value='医师'>医师</Option>
                                                    <Option value='护理人员'>护理人员</Option>
                                                    <Option value='经济和金融专业人员'>经济和金融专业人员</Option>
                                                    <Option value='法律专业人员'>法律专业人员</Option>
                                                    <Option value='宗教教职人员'>宗教教职人员</Option>
                                                    <Option value='高等教育教师'>高等教育教师</Option>
                                                    <Option value='其他教学人员'>其他教学人员</Option>
                                                    <Option value='文学艺术、体育专业人员'>文学艺术、体育专业人员</Option>
                                                    <Option value='记者'>记者</Option>
                                                    <Option value='翻译'>翻译</Option>
                                                    <Option value='播音员、节目主持人'>播音员、节目主持人</Option>
                                                    <Option value='其他专业技术人员'>其他专业技术人员</Option>
                                                    <Option value='人民警察'>人民警察</Option>
                                                    <Option value='保卫人员'>保卫人员</Option>
                                                    <Option value='消防和应急救援人员'>消防和应急救援人员</Option>
                                                    <Option value='办事人员'>办事人员</Option>
                                                    <Option value='邮政和快递服务人员'>邮政和快递服务人员</Option>
                                                    <Option value='仓储人员'>仓储人员</Option>
                                                    <Option value='住宿和餐饮服务人员'>住宿和餐饮服务人员</Option>
                                                    <Option value='物业管理服务人员'>物业管理服务人员</Option>
                                                    <Option value='房地产中介服务人员'>房地产中介服务人员</Option>
                                                    <Option value='居民服务人员'>居民服务人员</Option>
                                                    <Option value='其他社会生产和生活服务人员'>其他社会生产和生活服务人员</Option>
                                                    <Option value='建筑施工人员'>建筑施工人员</Option>
                                                    <Option value='其他生产制造及相关人员'>其他生产制造及相关人员</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='nation' label='民族：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='politics' label='政治面貌：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Select placeholder="请选择">
                                                <Option value='中共党员'>中共党员</Option>
                                                <Option value='共青团员'>共青团员</Option>
                                                <Option value='民主党派'>民主党派</Option>
                                                <Option value='群众'>群众</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col> */}
                                        {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='marry' label='婚姻状况：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input disabled />
                                        </Form.Item>
                                    </Col> */}
                                        {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='education' label='文化程度：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input disabled />
                                        </Form.Item>
                                    </Col> */}
                                        {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='position' label='职业：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Select placeholder="请选择">
                                                <Option value='公共管理（公务员）'>公共管理（公务员）</Option>
                                                <Option value='公共管理（其他）'>公共管理（其他）</Option>
                                                <Option value='教师'>教师</Option>
                                                <Option value='医务人员'>医务人员</Option>
                                                <Option value='市容环卫'>市容环卫</Option>
                                                <Option value='公共交通'>公共交通</Option>
                                                <Option value='家政行业职工'>家政行业职工</Option>
                                                <Option value='保安行业职工'>保安行业职工</Option>
                                                <Option value='保洁行业职工'>保洁行业职工</Option>
                                                <Option value='物业行业职工'>物业行业职工</Option>
                                                <Option value='快递行业职工'>快递行业职工</Option>
                                                <Option value='绿化园林'>绿化园林</Option>
                                                <Option value='市政养护'>市政养护</Option>
                                                <Option value='应急保障'>应急保障</Option>
                                                <Option value='邮政行业职工'>邮政行业职工</Option>
                                                <Option value='电信部门职工'>电信部门职工</Option>
                                                <Option value='燃气部门职工'>燃气部门职工</Option>
                                                <Option value='养老机构职工'>养老机构职工</Option>
                                                <Option value='水务部门职工'>水务部门职工</Option>
                                                <Option value='电力部门职工'>电力部门职工</Option>
                                                <Option value='在职军官'>在职军官</Option>
                                                <Option value='物流职工'>物流职工</Option>
                                                <Option value='其他单位职工'>其他单位职工</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col> */}
                                        {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='telephone' label='手机号：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input disabled />
                                        </Form.Item>
                                    </Col> */}
                                        {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='registeredType' label='主申请人户口：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input disabled />
                                        </Form.Item>
                                    </Col> */}
                                        {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='province' label='户籍所在地：'
                                            rules={[{ required: true, message: '', }]}>
                                            {registeredType === '本市' ?
                                                <Cascader options={cityShangHai} placeholder="请选择" autoFocus={true}
                                                />
                                                :
                                                <Cascader options={city} placeholder="请选择" autoFocus={true}
                                                />}
                                        </Form.Item>
                                    </Col> */}
                                        {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='registeredAddress' label='详细地址(精确到门牌号)'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col> */}
                                        {/* {registeredType == '本市' ? <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name="registeredRight" label="是否为社区公共户"
                                            rules={[{ required: true, message: '请选择' }]}>
                                            <Select placeholder="请选择">
                                                <Option value='是'>是</Option>
                                                <Option value='否'>否</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col> : null} */}
                                        {/* {registeredType == '外省市' ? <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='holdLivingCardYear' label="是否持有有效期内本市居住证件"
                                            rules={[{ required: true, message: '请选择' }]}>
                                            <Select placeholder="请选择" disabled={dataList?.applyAttruble == '单位'}>
                                                <Option value='是'>是</Option>
                                                <Option value='否'>否</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col> : null} */}
                                        {/* {(sqTypes == '单位' && registeredType == '本市') || (sqTypes == '个人' && registeredType == '外省市') || (sqTypes == '单位' && registeredType == '外省市') ?
                                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Form.Item name='contributeSociety'
                                                label={(sqTypes == '单位' && registeredType == '本市') || (sqTypes == '个人' && registeredType == '外省市') ? '申请日前是否正常缴纳社保' : (sqTypes == '单位' && registeredType == '外省市') ? '社保和居住证是否在有效期内' : ''}
                                                rules={[{ required: true, message: '请选择' }]}>
                                                <Select placeholder="请选择">
                                                    <Option value='是'>是</Option>
                                                    <Option value='否'>否</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col> : null} */}
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ marginTop: 4 }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexWrap: 'nowrap',
                                                    alignItems: 'flex-start',
                                                    gap: 6,
                                                    lineHeight: '32px',
                                                    overflowX: 'auto',
                                                }}
                                            >
                                                <span style={{ color: '#ff4d4f', flexShrink: 0, marginTop: 4 }}>*</span>
                                                <span style={{ flexShrink: 0, marginTop: 4 }}>工作单位地址：</span>
                                                <Form.Item
                                                    className="modalWorkUnitAddrItem"
                                                    name="companyDistrict"
                                                    labelCol={{ span: 0 }}
                                                    wrapperCol={{ span: 24 }}
                                                    style={{ marginTop: 4, flexShrink: 0 }}
                                                    rules={[{ required: true, message: '' }]}
                                                >
                                                    <Select
                                                        style={{ minWidth: 110 }}
                                                        placeholder="请选择"
                                                        onChange={this.onWorkCompanyDistrictChange}
                                                    >
                                                        {SHANGHAI_DISTRICT_OPTIONS.map((d) => (
                                                            <Option key={d.value} value={d.value}>{d.label}</Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                                <span style={{ flexShrink: 0, marginTop: 4, lineHeight: '32px' }}>区</span>
                                                {showPudongWorkRingSection ? (
                                                    <>
                                                        <Form.Item
                                                            className="modalWorkUnitAddrItem"
                                                            name="companyPudongRing"
                                                            labelCol={{ span: 0 }}
                                                            wrapperCol={{ span: 24 }}
                                                            style={{ marginTop: 4, flexShrink: 0 }}
                                                            rules={[{ required: true, message: '' }]}
                                                        >
                                                            <Select style={{ minWidth: 110 }} placeholder="请选择">
                                                                <Option value="外环外">外环外</Option>
                                                                <Option value="外环内">外环内</Option>
                                                            </Select>
                                                        </Form.Item>
                                                        <span style={{ flexShrink: 0, marginTop: 4, lineHeight: '32px' }}>区域</span>
                                                    </>
                                                ) : null}
                                                <Form.Item name="workRoad" noStyle style={{ marginBottom: 0, flexShrink: 0 }}>
                                                    <Input style={{ width: 88, marginTop: 4 }} placeholder="请输入" />
                                                </Form.Item>
                                                <span style={{ flexShrink: 0, marginTop: 4, lineHeight: '32px' }}>路</span>
                                                <Form.Item name="workLane" noStyle style={{ marginBottom: 0, flexShrink: 0 }}>
                                                    <Input style={{ width: 88, marginTop: 4 }} placeholder="请输入" />
                                                </Form.Item>
                                                <span style={{ flexShrink: 0, marginTop: 4, lineHeight: '32px' }}>弄</span>
                                                <Form.Item name="workBranch" noStyle style={{ marginBottom: 0, flexShrink: 0 }}>
                                                    <Input style={{ width: 88, marginTop: 4 }} placeholder="请输入" />
                                                </Form.Item>
                                                <span style={{ flexShrink: 0, marginTop: 4, lineHeight: '32px' }}>支弄</span>
                                                <Form.Item name="workNo" noStyle style={{ marginBottom: 0, flexShrink: 0 }}>
                                                    <Input style={{ width: 88, marginTop: 4 }} placeholder="请输入" />
                                                </Form.Item>
                                                <span style={{ flexShrink: 0, marginTop: 4, lineHeight: '32px' }}>号</span>
                                                <Form.Item name="workRoom" noStyle style={{ marginBottom: 0, flexShrink: 0 }}>
                                                    <Input style={{ width: 88, marginTop: 4 }} placeholder="请输入" />
                                                </Form.Item>
                                                <span style={{ flexShrink: 0, marginTop: 4, lineHeight: '32px' }}>室</span>
                                            </div>
                                        </Col>
                                        <Form.Item noStyle shouldUpdate={(prev, cur) => prev.idType !== cur.idType}>
                                            {({ getFieldValue }) => {
                                                const isIdCard = getFieldValue('idType') === '身份证'
                                                return (
                                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <div style={{ lineHeight: 1.6, color: 'rgba(0,0,0,0.85)', marginTop: 8 }}>
                                                            <span style={{ color: '#ff4d4f', flexShrink: 0, marginTop: 4 }}>*</span>
                                                            主申请人{isIdCard ? '身份证' : '证件'}
                                                            {isIdCard ? (
                                                                <span style={{ color: '#ff4d4f' }}>（正反面）</span>
                                                            ) : (
                                                                <span style={{ color: '#ff4d4f' }}>（请上传有效证件）</span>
                                                            )}
                                                        </div>
                                                    </Col>
                                                )
                                            }}
                                        </Form.Item>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Form.Item
                                                name='身份证'
                                                label={false}
                                                colon={false}
                                                labelCol={{ span: 0 }}
                                                wrapperCol={{ span: 24 }}
                                                rules={[
                                                    idCardUploadValidator((getFieldValue) => getFieldValue('idType')),
                                                ]}
                                                dependencies={['idType']}
                                            >
                                                <Uploads
                                                    key={`modal-idcard-${dataList?.id || ''}-${(dataList && dataList['身份证']) ? String(dataList['身份证']).slice(0, 48) : '0'}`}
                                                    setImages={this.setMainSigningUploadImages}
                                                    indexImg='身份证'
                                                    indexImgTmp='身份证缩略'
                                                    serrArr={dataList && dataList['身份证'] ? dataList['身份证'] : ''}
                                                    serrArrTmp={dataList && dataList['身份证缩略'] ? dataList['身份证缩略'] : (dataList && dataList['身份证'] ? dataList['身份证'] : '')}
                                                />
                                            </Form.Item>
                                        </Col>
                                        {MARRY_CERT_SHOW_STATUSES.includes(signingMarry) ? (
                                            <>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <div style={{ lineHeight: 1.6, color: 'rgba(0,0,0,0.85)', marginTop: 8 }}>
                                                        {signingMarry === '已婚' ? (
                                                            <span style={{ color: '#ff4d4f', flexShrink: 0, marginTop: 4 }}>*</span>
                                                        ) : null}
                                                        结婚证
                                                    </div>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Form.Item
                                                        name='结婚证'
                                                        label={false}
                                                        colon={false}
                                                        labelCol={{ span: 0 }}
                                                        wrapperCol={{ span: 24 }}
                                                        rules={signingMarry === '已婚' ? [{ required: true, message: '请上传结婚证' }] : []}
                                                    >
                                                        <Uploads
                                                            key={`modal-main-结婚证-${dataList?.id || ''}-${(dataList && dataList['结婚证']) ? String(dataList['结婚证']).slice(0, 48) : '0'}`}
                                                            setImages={this.setMainSigningUploadImages}
                                                            indexImg='结婚证'
                                                            indexImgTmp='结婚证缩略'
                                                            serrArr={dataList && dataList['结婚证'] ? dataList['结婚证'] : ''}
                                                            serrArrTmp={dataList && dataList['结婚证缩略'] ? dataList['结婚证缩略'] : (dataList && dataList['结婚证'] ? dataList['结婚证'] : '')}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </>
                                        ) : null}
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <div style={{ lineHeight: 1.6, color: 'rgba(0,0,0,0.85)', marginTop: 8 }}>
                                                <span style={{ color: '#ff4d4f', flexShrink: 0, marginTop: 4 }}>*</span>
                                                主申请人就业证明（有效期的劳动合同或劳务合同、聘用协议
                                                毕业证书、录用通知、自主创业的工商登记等证明合法就业的材料）
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <div style={{ lineHeight: 1.6, color: '#ff4d4f', marginTop: 4 }}>
                                                签订年限页和最后盖章页都需上传
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Form.Item
                                                name='就业证明'
                                                label={false}
                                                colon={false}
                                                labelCol={{ span: 0 }}
                                                wrapperCol={{ span: 24 }}
                                                rules={[{ required: true, message: '请上传就业证明' }]}
                                            >
                                                <Uploads
                                                    key={`modal-main-就业证明-${dataList?.id || ''}-${(dataList && dataList['就业证明']) ? String(dataList['就业证明']).slice(0, 48) : '0'}`}
                                                    setImages={this.setMainSigningUploadImages}
                                                    indexImg='就业证明'
                                                    indexImgTmp='就业证明缩略'
                                                    serrArr={dataList && dataList['就业证明'] ? dataList['就业证明'] : ''}
                                                    serrArrTmp={dataList && dataList['就业证明缩略'] ? dataList['就业证明缩略'] : (dataList && dataList['就业证明'] ? dataList['就业证明'] : '')}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <div style={{ lineHeight: 1.6, color: 'rgba(0,0,0,0.85)', marginTop: 8 }}>
                                                <span style={{ color: '#ff4d4f', flexShrink: 0, marginTop: 4 }}>*</span>
                                                主申请人本市名下住房情况（进入随申办app或小程序，搜索“开具本市房屋查询结果证明”，申请提交成功后，可至“我的”-“我的办件”中查看进度，办结后可在“我的办
                                                件”和“亮证”中查看本市房屋查询结果证明{'\u3000\u3000\u3000'}
                                                <FlowImg
                                                    label="本市房屋查询结果调取教程"
                                                    imageSrc={HOUSING_QUERY_TUTORIAL_IMAGE}
                                                    showIcon={false}
                                                    clickableText
                                                />）
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <div style={{ lineHeight: 1.6, color: '#ff4d4f', marginTop: 4 }}>
                                                若有未成年子女，未成年子女可上传父母的住房证明
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                            <Form.Item
                                                name='住房情况'
                                                label={false}
                                                colon={false}
                                                labelCol={{ span: 0 }}
                                                wrapperCol={{ span: 24 }}
                                                rules={[{ required: true, message: '请上传住房情况证明' }]}
                                            >
                                                <Uploads
                                                    key={`modal-main-住房情况-${dataList?.id || ''}-${(dataList && dataList['住房情况']) ? String(dataList['住房情况']).slice(0, 48) : '0'}`}
                                                    setImages={this.setMainSigningUploadImages}
                                                    indexImg='住房情况'
                                                    indexImgTmp='住房情况缩略'
                                                    serrArr={dataList && dataList['住房情况'] ? dataList['住房情况'] : ''}
                                                    serrArrTmp={dataList && dataList['住房情况缩略'] ? dataList['住房情况缩略'] : (dataList && dataList['住房情况'] ? dataList['住房情况'] : '')}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                                {/* <Card title={<div id="application" style={{ borderLeft: '3px solid #1890FF', padding: '0 0 0 5px', fontWeight: 'bold' }}>主申请人单位信息</div>} bordered={false}>
                                <Row gutter={[48, 8]}>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='companyName' label='单位全称：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='companyCategory' label='单位类别：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Select placeholder="请选择">
                                                <Option value='机关单位'>机关单位</Option>
                                                <Option value='事业单位'>事业单位</Option>
                                                <Option value='国有企业'>国有企业</Option>
                                                <Option value='集体企业'>集体企业</Option>
                                                <Option value='外资企业'>外资企业</Option>
                                                <Option value='合资企业'>合资企业</Option>
                                                <Option value='私营企业'>私营企业</Option>
                                                <Option value='港澳台企业'>港澳台企业</Option>
                                                <Option value='社会团体'>社会团体</Option>
                                                <Option value='个体工商户'>个体工商户</Option>
                                                <Option value='非正规就业劳动组织'>非正规就业劳动组织</Option>
                                                <Option value='其他'>其他</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='companyLegally' label='单位法人：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='companyAddress' label='单位地址：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='companyTelephone' label='单位电话：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='companyZipcode' label='单位邮编：'
                                            rules={[{ required: false, message: '', }]}>
                                            <Input disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='companyRegisteredAddress' label='注册地址：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Select placeholder="请选择" onChange={this.companyRegisteredBtn}>
                                                <Option value='宝山区'>宝山区</Option>
                                                <Option value='其他'>其他</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='companyYyzz' label='统一社会信用代码：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='companyAuthorize' label='单位授权经办人：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item name='companyAuthorizeTelephone' label='经办人电话：'
                                            rules={[{ required: true, message: '', }]}>
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card> */}
                                {signingApplyType ? (
                                    <Form.List name="signingConfirmationApplicantBeanList">
                                        {(fields, { add, remove }) => (
                                            <>
                                                {fields.map((field, index) => (
                                                    <Card
                                                        key={field.key}
                                                        title={<div id="application" style={{ borderLeft: '3px solid #1890FF', padding: '0 0 0 5px', fontWeight: 'bold' }}>共同申请人{index + 1}</div>}
                                                        bordered={false}
                                                        extra={(signingApplyType === '单身人士' ? fields.length >= 1 : fields.length > 1) ? (
                                                            <Button
                                                                type="link"
                                                                danger
                                                                size="small"
                                                                onClick={() => {
                                                                    remove(field.name)
                                                                    const refs = [...(this.jointAdditionListRefs || [])]
                                                                    refs.splice(index, 1)
                                                                    this.jointAdditionListRefs = refs
                                                                }}
                                                            >
                                                                删除
                                                            </Button>
                                                        ) : null}
                                                    >
                                                        <Row gutter={[48, 8]}>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <Form.Item
                                                                    {...field}
                                                                    label="是否本市户籍："
                                                                    name={[field.name, 'localHousehold']}
                                                                    fieldKey={[field.fieldKey, 'localHousehold']}
                                                                    rules={[{ required: true, message: '' }]}
                                                                >
                                                                    <Select placeholder="请选择">
                                                                        <Option value={'是'}>是</Option>
                                                                        <Option value={'否'}>否</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <Form.Item
                                                                    {...field}
                                                                    label="与主申请人关系："
                                                                    name={[field.name, 'relation']}
                                                                    fieldKey={[field.fieldKey, 'relation']}
                                                                    rules={[{ required: true, message: '' }]}
                                                                >
                                                                    <Select placeholder="请选择">
                                                                        <Option value={'配偶'}>配偶</Option>
                                                                        <Option value={'子女'}>子女</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <Form.Item
                                                                    {...field}
                                                                    label="姓名："
                                                                    name={[field.name, 'username']}
                                                                    fieldKey={[field.fieldKey, 'username']}
                                                                    rules={[{ required: true, message: '' }]}
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                            </Col>
                                                            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                    <Form.Item
                                                        {...field}
                                                        label="性别："
                                                        name={[field.name, 'sex']}
                                                        fieldKey={[field.fieldKey, 'sex']}
                                                        rules={[{ required: true, message: '' }]}
                                                    >
                                                        <Select placeholder="请选择" disabled>
                                                            <Option value={'男'}>男</Option>
                                                            <Option value={'女'}>女</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col> */}
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <Form.Item
                                                                    {...field}
                                                                    label="证件类型："
                                                                    name={[field.name, 'idType']}
                                                                    fieldKey={[field.fieldKey, 'idType']}
                                                                    rules={[{ required: true, message: '' }]}
                                                                >
                                                                    <Select
                                                                        placeholder="请选择"
                                                                        onChange={() => this.refs.showFlagRef?.validateFields([['signingConfirmationApplicantBeanList', field.name, '身份证']])}
                                                                    >
                                                                        <Option value='身份证'>身份证</Option>
                                                                        <Option value='其他'>其他</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <Form.Item
                                                                    {...field}
                                                                    label="证件号码："
                                                                    name={[field.name, 'idno']}
                                                                    fieldKey={[field.fieldKey, 'idno']}
                                                                    rules={[{ required: true, message: '' }]}
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                            </Col>
                                                            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                    <Form.Item
                                                        {...field}
                                                        label="政治面貌："
                                                        name={[field.name, 'politics']}
                                                        fieldKey={[field.fieldKey, 'politics']}
                                                        rules={[{ required: true, message: '' }]}
                                                    >
                                                        <Select placeholder="请选择">
                                                            <Option value={'中共党员'}>中共党员</Option>
                                                            <Option value={'共青团员'}>共青团员</Option>
                                                            <Option value={'群众'}>群众</Option>
                                                            <Option value={'民主党派'}>民主党派</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                    <Form.Item
                                                        {...field}
                                                        label="婚姻状况："
                                                        name={[field.name, 'marry']}
                                                        fieldKey={[field.fieldKey, 'marry']}
                                                        rules={[{ required: true, message: '' }]}
                                                    >
                                                        <Select placeholder="请选择" disabled>
                                                            <Option value={'未婚'}>未婚</Option>
                                                            <Option value={'已婚'}>已婚</Option>
                                                            <Option value={'离异'}>离异</Option>
                                                            <Option value={'丧偶'}>丧偶</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                    <Form.Item
                                                        {...field}
                                                        label="共同申请人户口："
                                                        name={[field.name, 'relation']}
                                                        fieldKey={[field.fieldKey, 'relation']}
                                                        rules={[{ required: true, message: '' }]}
                                                    >
                                                        <Select placeholder="请选择" disabled>
                                                            <Option value={'本市'}>上海市</Option>
                                                            <Option value={'外省市'}>外省市</Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col> */}
                                                            <Form.Item
                                                                noStyle
                                                                shouldUpdate={(prev, cur) => {
                                                                    const prevType = prev.signingConfirmationApplicantBeanList?.[field.name]?.idType
                                                                    const curType = cur.signingConfirmationApplicantBeanList?.[field.name]?.idType
                                                                    return prevType !== curType
                                                                }}
                                                            >
                                                                {({ getFieldValue }) => {
                                                                    const isIdCard = getFieldValue(['signingConfirmationApplicantBeanList', field.name, 'idType']) === '身份证'
                                                                    return (
                                                                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                            <div style={{ lineHeight: 1.6, color: 'rgba(0,0,0,0.85)', marginTop: 8 }}>
                                                                                <span style={{ color: '#ff4d4f', flexShrink: 0, marginTop: 4 }}>*</span>
                                                                                共同申请人{index + 1}{isIdCard ? '身份证' : '证件'}
                                                                                {isIdCard ? (
                                                                                    <span style={{ color: '#ff4d4f' }}>（正反面/未成年子女可上传户籍证明）</span>
                                                                                ) : (
                                                                                    <span style={{ color: '#ff4d4f' }}>（请上传有效证件）</span>
                                                                                )}
                                                                            </div>
                                                                        </Col>
                                                                    )
                                                                }}
                                                            </Form.Item>
                                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                <Form.Item
                                                                    {...field}
                                                                    name={[field.name, '身份证']}
                                                                    fieldKey={[field.fieldKey, '身份证']}
                                                                    label={false}
                                                                    colon={false}
                                                                    labelCol={{ span: 0 }}
                                                                    wrapperCol={{ span: 24 }}
                                                                    rules={[
                                                                        idCardUploadValidator((getFieldValue) => getFieldValue(['signingConfirmationApplicantBeanList', field.name, 'idType'])),
                                                                    ]}
                                                                    dependencies={[['signingConfirmationApplicantBeanList', field.name, 'idType']]}
                                                                >
                                                                    <Uploads
                                                                        key={`modal-joint-idcard-${index}-${(dataList?.signingConfirmationApplicantBeanList && dataList.signingConfirmationApplicantBeanList[index] && dataList.signingConfirmationApplicantBeanList[index].idno) || index}-${(dataList?.signingConfirmationApplicantBeanList && dataList.signingConfirmationApplicantBeanList[index] && dataList.signingConfirmationApplicantBeanList[index]['身份证']) ? String(dataList.signingConfirmationApplicantBeanList[index]['身份证']).slice(0, 48) : '0'}`}
                                                                        setImages={this.setJointIdCardImages}
                                                                        indexImg='身份证'
                                                                        indexImgTmp='身份证缩略'
                                                                        indexUp={index}
                                                                        data={{ name: 'signingConfirmationApplicantBeanList', transactionAdditionType: '共同申请人附件' }}
                                                                        serrArr={
                                                                            dataList?.signingConfirmationApplicantBeanList?.[index]?.['身份证']
                                                                                ? dataList.signingConfirmationApplicantBeanList[index]['身份证']
                                                                                : ''
                                                                        }
                                                                        serrArrTmp={
                                                                            dataList?.signingConfirmationApplicantBeanList?.[index]?.['身份证缩略']
                                                                                ? dataList.signingConfirmationApplicantBeanList[index]['身份证缩略']
                                                                                : (dataList?.signingConfirmationApplicantBeanList?.[index]?.['身份证']
                                                                                    ? dataList.signingConfirmationApplicantBeanList[index]['身份证']
                                                                                    : '')
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                <div style={{ lineHeight: 1.6, color: 'rgba(0,0,0,0.85)', marginTop: 8 }}>
                                                                    <span style={{ color: '#ff4d4f', flexShrink: 0, marginTop: 4 }}>*</span>
                                                                    共同申请人{index + 1}本市名下住房情况（进入随申办app或小程序，搜索“开具本市房屋查询结果证明”，申请提交成功后，可至“我的”-“我的办件”中查看进度，办结后可在“我的办
                                                                    件”和“亮证”中查看本市房屋查询结果证明{'\u3000\u3000\u3000'}
                                                                    <FlowImg
                                                                        label="本市房屋查询结果调取教程"
                                                                        imageSrc={HOUSING_QUERY_TUTORIAL_IMAGE}
                                                                        showIcon={false}
                                                                        clickableText
                                                                    />）
                                                                </div>
                                                            </Col>
                                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                                <Form.Item
                                                                    {...field}
                                                                    name={[field.name, '住房情况']}
                                                                    fieldKey={[field.fieldKey, '住房情况']}
                                                                    label={false}
                                                                    colon={false}
                                                                    labelCol={{ span: 0 }}
                                                                    wrapperCol={{ span: 24 }}
                                                                    rules={[{ required: true, message: '请上传住房情况证明' }]}
                                                                >
                                                                    <Uploads
                                                                        key={`modal-joint-住房情况-${index}-${(dataList?.signingConfirmationApplicantBeanList && dataList.signingConfirmationApplicantBeanList[index] && dataList.signingConfirmationApplicantBeanList[index].idno) || index}-${(dataList?.signingConfirmationApplicantBeanList && dataList.signingConfirmationApplicantBeanList[index] && dataList.signingConfirmationApplicantBeanList[index]['住房情况']) ? String(dataList.signingConfirmationApplicantBeanList[index]['住房情况']).slice(0, 48) : '0'}`}
                                                                        setImages={this.setJointIdCardImages}
                                                                        indexImg='住房情况'
                                                                        indexImgTmp='住房情况缩略'
                                                                        indexUp={index}
                                                                        data={{ name: 'signingConfirmationApplicantBeanList', transactionAdditionType: '共同申请人附件' }}
                                                                        serrArr={
                                                                            dataList?.signingConfirmationApplicantBeanList?.[index]?.['住房情况']
                                                                                ? dataList.signingConfirmationApplicantBeanList[index]['住房情况']
                                                                                : ''
                                                                        }
                                                                        serrArrTmp={
                                                                            dataList?.signingConfirmationApplicantBeanList?.[index]?.['住房情况缩略']
                                                                                ? dataList.signingConfirmationApplicantBeanList[index]['住房情况缩略']
                                                                                : (dataList?.signingConfirmationApplicantBeanList?.[index]?.['住房情况']
                                                                                    ? dataList.signingConfirmationApplicantBeanList[index]['住房情况']
                                                                                    : '')
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                ))}
                                                {fields.length < 4 ? (
                                                    <Row gutter={[48, 8]}>
                                                        <Col span={24}>
                                                            <Button
                                                                type="dashed"
                                                                block
                                                                onClick={() => {
                                                                    add({})
                                                                    this.jointAdditionListRefs = [
                                                                        ...(this.jointAdditionListRefs || []),
                                                                        defaultJointAdditionListRef(),
                                                                    ]
                                                                }}
                                                            >
                                                                添加共同申请人
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                ) : null}
                                            </>
                                        )}
                                    </Form.List>
                                ) : null}
                            </div>
                            <Checkbox style={{ marginTop: '12px' }} onChange={(e) => {
                                if (!showCheckFlag) {
                                    this.setState({ secondsToChecked: e.target.checked })
                                }
                            }} checked={this.state.secondsToChecked}>
                                {
                                    window.innerWidth > 500 ? <div>
                                        <p>勾选即代表：1.确认签约本次房源。</p>
                                        <p>2.确认上述填报的材料准确属实，如有疑问可咨询:56671727（上午8:45~11:30、下午1:30~4:30，周一至周六(法定节假日除外)）。</p>
                                        <p>3.如资格审核不通过将取消签约入住资格。</p>
                                        <p>4.如确认后需取消签约视为放弃，需重新登记。</p>
                                    </div> :
                                        <div>
                                            <p>勾选即代表：<a onClick={(event) => {
                                                this.setState({ showInFlag: true, showCheckFlag: true });
                                            }}>点击查看</a></p>
                                        </div>
                                }
                            </Checkbox>
                            <Row>
                                <Col span={24} style={{ textAlign: 'center', marginTop: '2em' }}>
                                    <Button type="primary" htmlType="submit" disabled={!this.state.secondsToChecked} >
                                        {renewalMode ? '提交' : '确认签约'}
                                        {/* handleOkAndhandleCancel */}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
                <Modal visible={showInFlag} closable={false} maskClosable={false}
                    footer={<Button type="primary" onClick={() => { this.setState({ showInFlag: false, showCheckFlag: false }) }} style={{ display: 'flex', margin: '0 auto' }}>
                        确 认
                    </Button>}>
                    <p>1.确认签约本次房源，同时取消其他登记，如确认后需取消签约视为放弃一次配租资格，放弃两次配租资格的申请人2年内不得重新提出申请。</p>
                    <p>2.确认以上信息填写准确无误，如有填写错误可能会影响合同签订。如因填写错误导致合同签订失败，后果自负。</p>
                    <p>3.灰色部分信息为资格证申请关联数据信息，如有变动请联系021-56671727或021-56100661。</p>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(modalBox))